import { environment as developmentConfig } from "./environment.dev";
import { environment as localDevelopmentConfig } from "./environment.localdev";
import { environment as productionConfig } from "./environment.prod";
import { environment as localProductionConfig } from "./environment.localprod";
import { Environment } from "../interfaces/Environment";

type EnvType = "localdevelopment" | "development" | "localproduction" | "production";

const envMap: Record<EnvType, Environment> = {
    localdevelopment: localDevelopmentConfig,
    development: developmentConfig,
    localproduction: localProductionConfig,
    production: productionConfig,
};

const envKey = (process.env.REACT_APP_ENV as EnvType) ?? "development";

const environment: Environment = envMap[envKey];

export default environment;
